import { pickSupportedMimeType } from './audioMime';

// PARA-132 (AC-E9) — feature-detection записи. Разрешений НЕ запрашивает:
// getUserMedia здесь не вызывается, проверяется только наличие API.

export function isVoiceRecordingSupported(): boolean {
  if (
    typeof navigator === 'undefined' ||
    typeof navigator.mediaDevices?.getUserMedia !== 'function'
  ) {
    return false;
  }
  if (typeof MediaRecorder === 'undefined') {
    return false;
  }
  return pickSupportedMimeType() !== null;
}
